export default __webpack_public_path__ + "static/media/logo_narrow.f0a5957c.svg";